import { AxiosResponse } from "axios";
import { SERVERURL } from "../globals/constants";
import { Profile } from "../models/Profile";
import { UserStore } from "../stores/useProfile";
import { Set } from "../models/global/Set";
import { LoginDto } from "../models/dto/LoginDTO";
import axios from "./axiosConfig";


export const getProfile = async (set: Set<UserStore>, loginData: LoginDto) => {
  try {
    const response: AxiosResponse = await axios.post<Profile>(
      `${SERVERURL}/user/login`,
      loginData,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    set((state) => ({ ...state, user: response.data }));
    localStorage.setItem("user", JSON.stringify(response.data));
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
